import { render, staticRenderFns } from "./SignupRedirect.vue?vue&type=template&id=137a1f08&"
import script from "./SignupRedirect.vue?vue&type=script&lang=ts&"
export * from "./SignupRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports